<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="approvalProcess" :class="{'isNews': isNews}">
            <van-nav-bar
                title="审批办理"
                left-arrow
                right-text="流程"
                :style="`height: ${ $getNavHeight() }px;`"
                @click-left="swiperright"
                @click-right="openHandlingProcess"
            >
            </van-nav-bar>
            <section :class="{'readOnly': isReadOnly || phaseType == 0 || transferState > 1}">
                <van-tabs v-model="active" animated line-width="80">
                    <van-tab title="基本信息表" class="essentialInfo">
                        <van-collapse v-model="activeCollapseItem">
                            <van-collapse-item title="基本信息" name="1">
                                <template v-for="(item, index) in essentialInfoField">
                                    <template v-if="item.IsShow">
                                        <template v-if="essentialInfoData">
                                            <van-cell
                                                v-if="item.Methed != null || item.Field == 'engineering_location'"
                                                :key="index"
                                                :value="essentialInfoData[item.Field]"
                                                :title="item.FieldName"
                                            ></van-cell>
                                            <van-cell
                                                v-else
                                                :key="index"
                                                :value="essentialInfoData[item.Field]"
                                                :title="item.FieldName"
                                            ></van-cell>
                                        </template>
                                        <template v-else>
                                            <van-cell
                                                v-if="item.Methed != null || item.Field == 'engineering_location'"
                                                :key="index"
                                                value=""
                                                :title="item.FieldName"
                                                is-link
                                            ></van-cell>
                                            <van-cell
                                                v-else
                                                :key="index"
                                                value=""
                                                :title="item.FieldName"
                                            ></van-cell>
                                        </template>
                                    </template>
                                </template>
                            </van-collapse-item>
                        </van-collapse>
                    </van-tab>
                    <van-tab title="审批表单">
                        <template v-for="(item, index) in formData">
                            <van-cell
                                is-link
                                v-if="item.IsVisibleApp"
                                class="formList iconfont sm-hetong"
                                :key="index"
                                :title="item.FormName"
                                @click="openForm(item)"
                            >
                            </van-cell>
                        </template>
                    </van-tab>
                    <van-tab title="附件资料">
                        <div class="appendix_list">
                            <button v-if="thisFileID != '0'" class="attachmentReturnBtn iconfont sm-fanhui" @click="attachmentReturn">
                                返回上一级
                            </button>
                            <ul>
                                <template v-for="(item, index) in attachmentData">
                                    <li :key="`attachment_${index}`" :class="{'folder':item.FileType == '1', 'file': item.FileType == '2'}" @click="attachmentPreview(item)">
                                        <span class="iconfont fileIcon" :class="addClassName(item)"></span>
                                        <div class="fileInfo">
                                            <p class="fileName">
                                                {{ item.FileName }}
                                            </p>
                                            <p v-if="item.FileType !== '1'">
                                                <em>{{ item.CreateDate || '暂无日期' }}</em>
                                                <em v-if="item.FileType !== '1'">
                                                    <template v-if="item.FileSize > 1048576">
                                                        {{ (item.FileSize/1048576).toFixed(2) }}M
                                                    </template>
                                                    <template v-else-if="item.FileSize < 1048576 && item.FileSize > 1024">
                                                        {{ (item.FileSize/1024).toFixed(2) }}k
                                                    </template>
                                                    <template v-else>
                                                        {{ item.FileSize }}b
                                                    </template>
                                                </em>
                                            </p>
                                        </div>
                                        <i class="iconfont sm-fanhui1"></i>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </van-tab>
                    <van-tab title="审批动态">
                        <div class="flowChartList">
                            <template v-for="(item,index) in dynamicData">
                                <div class="procedureList" :class="{'countersignatureNode': item.node_type ==3}" :key="index">
                                    <h3 class="countersignatureTitle" v-if="item.node_type ==3">
                                        <i class="iconfont sm-05qunzufill"></i>
                                        会签审核
                                    </h3>
                                    <template v-for="(k, i) in item.data">
                                        <div class="listBox" :key="i">
                                            <h4>{{ k.Content }}</h4>
                                            <div class="userInfo">
                                                <span class="headPortrait">
                                                    <p>{{ k.ApproverName.substring(0, 2) }}</p>
                                                    <i class="icon" :class="{'icon_pass': k.TransferState != 0}"></i>
                                                </span>
                                                <div class="stateBox">
                                                    <span class="name">{{ k.ApproverName }}</span>
                                                    <span class="time">{{ k.EndTime }}</span>
                                                    <span class="state">（{{ k.ParticipantAction }}）</span>
                                                </div>
                                            </div>
                                            <div v-if="(k.Opinions||[]).length>0" :class="{'opinions':true,'show-all':k.Opinions[0].showAll}">
                                                <div class="opinion-text">
                                                    意见：{{ k.Opinions[0].opinion }}
                                                </div>
                                                <span class="iconfont sm-shuangjiantouxia" @click="showOrHideOption(k.Opinions[0])"></span>
                                            </div>
                                            <ul class="commentList" v-if="(k.CommentList || []).length > 0">
                                                <template v-for="(z, j) in k.CommentList">
                                                    <li :key="`comment_${j}`">
                                                        <div class="comment">
                                                            意见：{{ z.Content }}
                                                        </div>
                                                    </li>
                                                </template>
                                            </ul>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </div>
                    </van-tab>
                </van-tabs>
                <!-- <button class="communicate" @click="communicate">
                    <p class="iconfont sm-goutong"></p>
                    沟通
                </button> -->
                <button class="opinion" v-if="isReadOnly == false && currentView != 'read'" @click="opinion">
                    <p class="iconfont sm-yijian"></p>
                    <span>意见</span>
                </button>

                <van-badge class="tips" v-if="businessRemindList.length > 0" :content="businessRemindList.length">
                    <button class="tipsBtn" @click="openAllTips">
                        <p class="iconfont sm-tishi"></p>
                        <span>提示</span>
                    </button>
                    <div v-if="showTipsPopover" class="tipsPopover">
                        <i class="iconfont sm-tishi"></i>
                        <span></span>
                        <button class="iconfont sm-guanbi" @click="promptReadClick"></button>
                        <p>{{ showUnreadData.RemindContent }}</p>
                    </div>
                </van-badge>
                <!-- 所有提示展示层 -->
                <van-popup v-model="showAllTips" class="flowPathTips">
                    <ul>
                        <template v-for="(item, index) in businessRemindList">
                            <li :key="`tips_${index}`">
                                <div>
                                    <i class="state" v-if="item.RecordStatus == 0">最新</i>
                                    <i class="state read" v-if="item.RecordStatus == 1">已读</i>
                                    <p>{{ item.RemindContent }}</p>
                                </div>
                                <p class="iconfont sm-shijian">
                                    {{ item.CreateDate }}
                                </p>
                            </li>
                        </template>
                    </ul>
                    <van-button plain type="info" @click="allpromptReadClick">
                        我知道了
                    </van-button>
                </van-popup>
            </section>
            <footer v-if="isReadOnly == false">
                <!-- <footer v-if="isReadOnly == false && phaseType != 0 && transferState < 2"> -->
                <div id="btngroup" v-if="BusinessActionList.length > 3">
                    <van-popover
                        v-model="showMoreBtn"
                        trigger="click"
                        get-container=".approvalProcess"
                        placement="top-start"
                    >
                        <div
                            class="moreBtn-item"
                            :key="`processButton_${index}`"
                            v-for="(item, index) in BusinessActionList.slice(3)"
                            @click="btnClick(item)"
                        >
                            {{ item.CustomName || item.ActionName }}
                        </div>
                        <template #reference>
                            <van-button type="primary" class="moreBtn">
                                更多
                            </van-button>
                        </template>
                    </van-popover>
                </div>
                <template v-for="(item, index) in BusinessActionList.slice(0,3)">
                    <van-button :key="`footerBtn_${index}`" @click="btnClick(item)">
                        {{ item.CustomName || item.ActionName }}
                    </van-button>
                </template>
            </footer>
            <!-- 提交确认弹出层 -->
            <van-dialog
                title="提交确认"
                class="submitPopUp"
                show-cancel-button
                v-model="confirmedByShow"
                @cancel="cancelSubmission"
                @confirm="confirmSubmission"
            >
                <div class="submitPopUpContent">
                    <div class="icon">
                        <img src="@/assets/images/contractApproval/icon.png" alt="">
                    </div>
                    <div class="info linkInfo">
                        <h4>
                            下一环节：
                            <span>{{ submitObj.link }}</span>
                        </h4>
                        <h4>
                            审批人：
                            <span>{{ submitObj.obj }}</span>
                        </h4>
                        <p>是否确认提交？</p>
                    </div>
                </div>
            </van-dialog>
            <!-- 审批流程弹出 -->
            <van-popup closeable v-model="showApprovalProcess" class="approvalProcessPopUp">
                <header>审批流程</header>
                <ul>
                    <template v-for="(item, index) in approvalPhaseData">
                        <li class="processNode" :key="`processNode_${index}`">
                            <div class="nodeIcon">
                                <span v-if="item.node_type === 3" class="iconfont sm-qunzu countersignatureIcon"></span>
                                <span v-else-if="index === 0" class="startNodeIcon">始</span>
                                <span v-else-if="index === (approvalPhaseData.length - 1)" class="endNodeIcon">末</span>
                                <span v-else class="intermediateNodeIcon"></span>
                            </div>
                            <div class="nodeList" :class="{'countersignatureNode': item.node_type === 3}">
                                <span class="angleSign iconfont sm-jiaobiao1" v-if="item.node_type === 3">
                                    <i>会签</i>
                                </span>
                                <template v-for="(k,z) in item.data">
                                    <div class="childNode" :key="`childNode_${z}`">
                                        <div>
                                            <i class="iconfont sm-04gerenfill"></i>
                                            <span v-if="k.ApproverType ===1" :title="k.ApproverName">{{ k.ApproverName }}</span>
                                            <span v-else :title="k.ApproverRoleName">{{ k.ApproverRoleName }}</span>
                                        </div>
                                        <p>{{ k.BusinessPhaseName }}</p>
                                    </div>
                                </template>
                            </div>
                        </li>
                    </template>
                </ul>
            </van-popup>
        </div>
    </v-touch>
</template>
<script>
import { ImagePreview } from 'vant';
import { mixin_MessageJump } from '@/assets/mixin/mixin_MessageJump';
export default {
    // 审批办理
    name: 'approval-process',
    mixins: [mixin_MessageJump],
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (![
                'approvalComments',
                'formPreview',
                'submission',
                'ProjectLocation',
                'attachmentPreview',
                'appForm_procurementPlanSummary',
                'appForm_departmentalPlan_dby',
                'appForm_departmentalPlan_hlj',
                'appForm_flakeGraphitePriceForm',
            ].includes(from.name)) {
                vm.backPathName = from.name;
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === this.backPathName) {
            this.$store.commit('noKeepAlive', 'approval-process');
        }
        next();
    },
    props: {},
    data() {
        return {
            // 审批动态流程节点下标
            currentStep: 0,
            // 当前tab页下标
            active: 0,
            // 是否只读
            isReadOnly: false,
            // 审批数据
            approvalData: {},
            // 基本信息字段数据
            essentialInfoField: [],
            // 基本信息数据
            essentialInfoData: [],
            activeCollapseItem: ['1'],
            // 合同编号（沟通用）
            contractNo: '',
            // 流程数据
            processData: {},
            // 流程环节类型
            phaseType: 0,
            // 审批状态
            transferState: 0,
            // 表单数据
            formData: [],
            // 显示附件数据
            attachmentData: [],
            // 所有附件数据
            allAttachmentData: [],
            attachmentActive: [],
            thisFileID: '0',
            // 审批动态数据
            dynamicData: [],
            // 当前流程环节信息
            CurrentBusinessProcess: {},
            // 当前流程基本信息
            BusinessInstanceInfo: {},
            // 按钮集合
            BusinessActionList: [],
            // 环节审批角色id
            approverRoleId: [],
            // 环节审批角色name
            approverRoleName: [],
            // 确认人员弹出层状态
            confirmedByShow: false,
            confirmData: null,
            submitObj: {},
            // 附件预览地址
            url: '',
            // 是否是消息跳转审批
            isNews: false,
            // 是否填写意见
            isOpinion: false,
            // 是否需要填写意见
            isFillOpinion: true,
            // 是否需要填写意见[退回]
            isFillOpinion_return: true,
            // 多租户消息跳转办理页面
            // 取当前消息租户token
            newsToken: '',

            // 提示数据集合
            businessRemindList: [],
            // 流程提示[有未读提示显示]
            showTipsPopover: null,
            // 显示未读[显示所有未读提示最后一条]
            showUnreadData: {},
            // 所有提示弹出层状态
            showAllTips: false,

            // 返回的页面 name
            backPathName: '',

            // 显示更多操作按钮
            showMoreBtn: false,

            /**
             * 审批流程弹出
             * 2022年6月10日15:06:29
             */
            showApprovalProcess: false,
            // 流程数据
            approvalPhaseData: [],
            // 当前视图
            currentView: 'view',
        };
    },
    computed: {},
    watch: {
        businessRemindList(newVal) {
            if (newVal.length > 0) {
                // 显示未读[显示所有未读提示最后一条]
                const unreadData = newVal.filter(item => item.RecordStatus === 0);
                if (unreadData.length > 0) {
                    this.showUnreadData = unreadData[unreadData.length - 1];
                    this.showTipsPopover = true;
                } else {
                    this.showTipsPopover = false;
                }
            }
        },
    },
    created() {},
    activated() {
        // if (this.$route.params.commentsCallback) {
        // 拉取审批意见
        this.getApprovalComments();
        // }
        if (this.$route.params.isRefresh) {
            this.isReadOnly = true;
        }
    },
    async mounted() {
        await this.init();
    },
    destroyed() {},
    methods: {
        // 返回上级页面
        swiperright() {
            if (this.isNews !== true) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: this.backPathName,
                });
            }
        },
        // 初始化页面
        async init() {
            // 读取父页面审批数据
            if (this.$route.params.data) {
                this.approvalData = this.$route.params.data;
                if (!this.approvalData.business_instance_id) {
                    this.approvalData.business_instance_id = this.approvalData.BusinessInstanceId ? this.approvalData.BusinessInstanceId : '';
                }
                this.isNews = this.$route.params.isNews;
                // 是否已审批，已审批只读
                if (this.$route.params.isReadOnly) {
                    this.isReadOnly = this.$route.params.isReadOnly;
                } else {
                    this.isReadOnly = false;
                }
                if (this.$route.params.platformEnterprises) {
                    // 平台账号打开办理页面获取数据中企业账号token
                    const res = await this.getTenantToken(this.$route.params.platformEnterprises);
                    this.newsToken = `${res.token_type} ${res.access_token}`;
                } else if (this.isNews && this.approvalData.tenant_id) {
                    // 有tenant_id，消息列表跳转办理页面，判断多租户
                    await this.getNewsToken(this.approvalData.tenant_id);
                }
                // 获取流程数据
                await this.getProcessData();
                // 获取基本信息字段数据
                await this.getEssentialInfoField();
            }
            // 转发原生回调函数
            window.callback_GetTeamsListInfo = this.callback_GetTeamsListInfo;
        },
        // 获取基本信息字段数据
        async getEssentialInfoField() {
            this.essentialInfoField = await this.getEssentialInfoFieldRequest();
            // 获取基本信息数据
            this.essentialInfoData = [];
            this.contractNo = '';
            this.getEssentialInfoData();
        },
        // 获取基本信息数据
        async getEssentialInfoData() {
            const res = await this.getEssentialInfoDataRequest();
            if (res) {
                this.essentialInfoData = res;
                this.contractNo = res.contract_number;
            }
            this.$forceUpdate();
        },
        // 根据环节获取流程实例信息
        async getProcessData() {
            if (this.isReadOnly) {
                this.processData = await this.getProcessDataRequest_view();
            } else if (this.$route.params.view || this.approvalData.sceneCode) {
                this.currentView = this.$route.params.view || this.approvalData.sceneCode;
                this.processData = await this.getProcessDataRequest_view(this.currentView);
            } else {
                this.processData = await this.getProcessDataRequest();
            }
            // 表单数据赋值
            this.formData = this.processData.BusinessFormList;
            // 附件数据赋值
            this.allAttachmentData = this.processData.FileGroupInstanceList;
            if (this.processData.FileGroupInstanceList.length > 0) {
                // 附件数据处理
                this.processingAttachmentData(this.processData.FileGroupInstanceList);
            }
            // 审批动态数据
            this.dynamicData = this.processData.HistoryNewRecordList;
            // 当前流程基本信息
            this.BusinessInstanceInfo = this.processData.BusinessInstanceInfo;
            // 流程提示集合
            this.businessRemindList = this.processData.BusinessRemindList || [];
            // 按钮数据集合
            this.BusinessActionList = this.processData.BusinessActionList.filter(item => item.ActionCode !== 'save');
            // 当前流程环节信息
            this.CurrentBusinessProcess = this.processData.CurrentBusinessProcess;
            if (Object.keys(this.CurrentBusinessProcess || {}).length !== 0) {
                // 流程环节类型
                this.phaseType = this.CurrentBusinessProcess.PhaseType;
                // 审批状态
                this.transferState = this.CurrentBusinessProcess.TransferState;
                // IsNotRequiredOpinion = true意见选填，= false 意见必填
                // IsNotRequiredOpinionReturn = true退回意见选填，= false 退回意见必填
                if (!this.CurrentBusinessProcess.IsNotRequiredOpinion || !this.CurrentBusinessProcess.IsNotRequiredOpinionReturn) {
                    // 拉取审批意见
                    await this.getApprovalComments();
                }
                if (this.CurrentBusinessProcess.IsNotRequiredOpinion) {
                    this.isFillOpinion = false;
                } else {
                    this.isFillOpinion = true;
                }
                if (this.CurrentBusinessProcess.IsNotRequiredOpinionReturn) {
                    this.isFillOpinion_return = false;
                } else {
                    this.isFillOpinion_return = true;
                }
                // 没有后续流程提交按钮显示通过按钮
                if (this.CurrentBusinessProcess.SubmitPhaseModel === null) {
                    const submitBtn = this.processData.BusinessActionList.filter(item => item.ActionCode === 'submit');
                    if (submitBtn.length > 0) {
                        this.BusinessActionList = this.processData.BusinessActionList.filter(item => item.ActionCode !== 'submit');
                        const endBtn = this.BusinessActionList.filter(item => item.ActionCode === 'end');
                        if (endBtn.length === 0) {
                            this.BusinessActionList.push({
                                ActionCode: 'end',
                                ActionName: '通过',
                                Method: 'this.end();',
                            });
                        }
                    }
                }
            }
        },
        // 附件图标
        addClassName(item) {
            let className = '';
            if (item.FileType === '1') {
                className = 'sm-fujian';
            } else if (item.FileType === '0') {
                if (/png/i.test(item.FileName)) {
                    className = 'sm-tupian';
                } else if (/jpg/i.test(item.FileName)) {
                    className = 'sm-tupian';
                } else if (/gif/i.test(item.FileName)) {
                    className = 'sm-tupian';
                } else if (/pdf/i.test(item.FileName)) {
                    className = 'sm-pdf1';
                } else if (/docx/i.test(item.FileName)) {
                    className = 'sm-bg-word';
                } else if (/xlsx/i.test(item.FileName)) {
                    className = 'sm-xls';
                } else if (/ppt/i.test(item.FileName)) {
                    className = 'sm-ppt';
                } else if (/txt/i.test(item.FileName)) {
                    className = 'sm-txt';
                } else {
                    className = 'sm-ppt';
                }
            }
            return className;
        },
        // 附件数据处理
        processingAttachmentData(data) {
            const folderData = data.filter(item => item.ParentID === '0');
            if (folderData.length > 0) {
                this.attachmentData = folderData;
            } else {
                this.attachmentData = data;
            }
        },

        // 流程按钮触发后台配置事件钱验证执行条件
        async btnClick(btnInfo) {
            const btnEvent = btnInfo.Method;
            /*
            *   按钮执行前条件
            *   ExecuteCondition返回一个接口地址
            *   接口返回执行前条件或者提示
            */
            if ((btnInfo.ExecuteCondition || '') !== '') {
                let conditionUrl = '';
                const fields = btnInfo.ExecuteCondition.match('\\{([^}]*)\\}');
                if (fields.length > 0) {
                    if (fields[1] === 'BusinessInstanceId') {
                        conditionUrl = btnInfo.ExecuteCondition.replace(fields[0], this.approvalData.business_instance_id);
                    }
                } else {
                    conditionUrl = btnInfo.ExecuteCondition;
                }
                this.conditionData = await this.getExecuteCondition(conditionUrl);
                /**
                 * Code === '0' 0成功,继续操作
                 * Code === '1' 1提示,用户可取消或继续操作
                 * Code === '2' 2用户不可继续操作
                 * message 提示语
                 */
                if (this.conditionData.Code === '0') {
                    this.executeButtonMethod(btnEvent);
                } else if (this.conditionData.Code === '1') {
                    this.$dialog.confirm({
                        title: '提示',
                        message: `${this.conditionData.Message}, 是否继续?`,
                    }).then(() => {
                        this.executeButtonMethod(btnEvent);
                    }).catch(() => {
                        this.$toast('已取消');
                    });
                } else if (this.conditionData.Code === '2') {
                    this.$dialog.alert({
                        title: '提示',
                        cancelButtonText: '关闭',
                        message: `${this.conditionData.Message}。`,
                    });
                }
            } else {
                this.executeButtonMethod(btnEvent);
            }
        },
        // 执行按钮方法
        executeButtonMethod(btnEvent) {
            // eslint-disable-next-line no-eval
            eval(btnEvent);
        },

        // 提交
        async submit() {
            if (this.isFillOpinion) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }
            // 确认提交
            this.submitConfirm();
        },
        // 确认提交
        async submitConfirm() {
            let childrenData;
            // 获取环节数据请求
            const linkData = await this.getLinkDataRequest(this.approvalData.business_instance_id, this.CurrentBusinessProcess.CurrentBusinessProcessId);
            // 提交会签环节
            if (!linkData.SubmitPhaseModel && linkData.SubmitPhaseNodes) {
                childrenData = {
                    title: '会签提交',
                    type: 'countersign',
                    processData: this.processData,
                };
            } else if (linkData.PhaseSubmitMode === 1 && linkData.SubmitPhaseModel?.ApproverType === 2 && linkData.SubmitPhaseModel?.IsAllowEditApprover) {
                // 判断环节提交模式和审批人类别，环节提交模式=1（默认环节），审批人类别=2（角色），打开选择人员弹出层
                childrenData = {
                    title: '普通提交',
                    type: 'role',
                    processData: this.processData,
                };
                // 判断环节提交模式和审批人类别，环节提交模式=2或者=3（指定环节、自由环节）
            } else if (linkData.SubmitPhaseModel?.ApproverType === 5 || linkData.SubmitPhaseModel?.ApproverType === 6) {
                const topOrgInfo = await this.$axios.get(`/interfaceApi/basicplatform/depts/${this.BusinessInstanceInfo.InitiateOrgId}`);
                this.submitObj.link = linkData.SubmitPhaseModel?.BusinessPhaseName;
                this.submitObj.obj = linkData.SubmitPhaseModel?.ApproverType === 5 ? topOrgInfo.leader_name : topOrgInfo.executive_name;
                this.confirmedByShow = true;
                this.confirmData = {
                    BusinessInstanceId: this.approvalData.business_instance_id,
                    CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                    TransferMode: 10,
                    NextApproverIds: linkData.SubmitPhaseModel?.ApproverType === 5 ? topOrgInfo.leader_id : topOrgInfo.executive_id,
                    NextApproverNames: linkData.SubmitPhaseModel?.ApproverType === 5 ? topOrgInfo.leader_name : topOrgInfo.executive_name,
                };
            } else if (linkData.SubmitPhaseModel?.ApproverType === 99 && (linkData.SubmitPhaseModel?.ApproverCondition || '') !== '') {
                const conditionUrl = linkData.SubmitPhaseModel.ApproverCondition.replace('{BusinessInstanceId}', this.approvalData.business_instance_id);
                const approverList = await this.$axios.$get(conditionUrl, { token: this.newsToken });
                // 统一映射成 user_id / user_name，方便走既有提交逻辑
                const personnelList = (approverList || []).map(item => ({
                    user_id: item.UserId,
                    user_name: item.UserName,
                }));
                if (personnelList.length === 0) {
                    this.$message({ message: '当前未配置待选人员！', type: 'warning' });
                } else if (personnelList.length === 1) {
                    this.submitObj.link = linkData.SubmitPhaseModel?.BusinessPhaseName;
                    this.submitObj.obj = personnelList[0].user_name;
                    this.confirmData = {
                        BusinessInstanceId: this.approvalData.business_instance_id,
                        CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                        TransferMode: 10,
                    };
                    this.confirmedByShow = true;
                } else {
                    // 多人待选，跳转到 submission 组件选择人员
                    childrenData = {
                        title: '选择人员',
                        type: 'personnel',
                        processData: this.processData,
                        personnelList,
                        phaseName: linkData.SubmitPhaseModel?.BusinessPhaseName,
                    };
                }
            } else if ([2, 3].indexOf(linkData.PhaseSubmitMode) > -1) {
                childrenData = {
                    title: '自由提交',
                    type: 'link',
                    processData: this.processData,
                };
            } else {
                this.submitObj.link = linkData.SubmitPhaseModel?.BusinessPhaseName;
                this.submitObj.obj = linkData.SubmitPhaseModel?.ApproverName;
                this.confirmData = {
                    BusinessInstanceId: this.approvalData.business_instance_id,
                    CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                    TransferMode: 10,
                };
                this.confirmedByShow = true;
            }

            if (childrenData) {
                let pathName = this.backPathName;
                if (this.isNews) {
                    pathName = 'approvalProcess';
                }
                this.$router.isBack = 2;
                this.$router.push({
                    name: 'submission',
                    params: {
                        data: childrenData,
                        isNews: this.isNews,
                        backPathName: pathName,
                        thisToken: this.newsToken,
                    },
                });
            }
        },

        // 取消提交
        cancelSubmission() {
            this.$toast('已取消！');
        },

        // 确认提交
        confirmSubmission() {
            if (this.confirmData) {
                this.submitAPI(this.confirmData, '提交成功！', '/interfaceApi/basicplatform/simpleflow/processes');
            }
        },

        // 自由提交
        customSubmit() {
            this.$router.isBack = 2;
            const childrenData = {
                title: '自由提交',
                type: 'customSubmit',
                processData: this.processData,
            };
            let pathName = this.backPathName;
            if (this.isNews) {
                pathName = 'approvalProcess';
            }
            this.$router.push({
                name: 'submission',
                params: {
                    data: childrenData,
                    isNews: this.isNews,
                    backPathName: pathName,
                    thisToken: this.newsToken,
                    isOpinion: this.isOpinion,
                    isFillOpinion: this.isFillOpinion,
                    isFillOpinion_return: this.isFillOpinion_return,
                },
            });
        },

        // 自由回退
        customReturn() {
            this.$router.isBack = 2;
            const childrenData = {
                title: '自由回退',
                type: 'customReturn',
                processData: this.processData,
            };
            let pathName = this.backPathName;
            if (this.isNews) {
                pathName = 'approvalProcess';
            }
            this.$router.push({
                name: 'submission',
                params: {
                    data: childrenData,
                    isNews: this.isNews,
                    backPathName: pathName,
                    thisToken: this.newsToken,
                    isOpinion: this.isOpinion,
                    isFillOpinion: this.isFillOpinion,
                    isFillOpinion_return: this.isFillOpinion_return,
                },
            });
        },

        // 退回
        async sendBack() {
            if (this.isFillOpinion_return) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }
            const data = {
                BusinessInstanceId: this.approvalData.business_instance_id,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 21,
            };

            this.$dialog.confirm({
                message: '确认退回？',
            }).then(() => {
                this.submitAPI(data, '事项已退回!', '/interfaceApi/basicplatform/simpleflow/processes');
            }).catch(() => {
                this.$toast('取消退回！');
            });
        },
        // 流程通过
        async end() {
            if (this.isFillOpinion) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }

            const data = {
                BusinessInstanceId: this.approvalData.business_instance_id,
                CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 40,
            };

            this.$dialog.confirm({
                message: '确认通过流程审批？',
            }).then(() => {
                this.submitAPI(data, '事项已办结!', '/interfaceApi/basicplatform/simpleflow/processes');
            }).catch(() => {
                this.$toast('取消通过审批！');
            });
        },
        // 跨级审批
        async crossApproval() {
            if (this.isFillOpinion) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }

            const data = {
                BusinessInstanceId: this.approvalData.business_instance_id,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 10,
            };

            if (this.CurrentBusinessProcess) {
                this.$dialog.confirm({
                    title: '提交',
                    message: '确认提交?',
                }).then(() => {
                    this.submitAPI(data, '操作成功!', '/interfaceApi/basicplatform/simpleflow/crosshierarchy/approval');
                }).catch(() => {
                    this.$toast('已取消操作!');
                });
            } else {
                this.$message({
                    message: '请先保存表单!',
                    type: 'warning',
                });
            }
        },
        // 跨级退回
        async crossBackProcess() {
            if (this.isFillOpinion) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }

            const data = {
                BusinessInstanceId: this.approvalData.business_instance_id,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 21,
            };

            if (this.CurrentBusinessProcess) {
                this.$dialog.confirm({
                    title: '退回',
                    message: '确认退回?',
                }).then(() => {
                    this.submitAPI(data, '操作成功!', '/interfaceApi/basicplatform/simpleflow/crosshierarchy/approval');
                }).catch(() => {
                    this.$toast('已取消操作!');
                });
            } else {
                this.$message({
                    message: '请先保存表单!',
                    type: 'warning',
                });
            }
        },

        // 审核不通过
        async nopass() {
            if (this.isFillOpinion) {
                if (!this.isOpinion) {
                    this.$toast('请先填写意见！');
                    return;
                }
            }

            const data = {
                BusinessInstanceId: this.approvalData.business_instance_id,
                CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                TransferMode: 40,
                approval_status: 3,
            };

            this.$dialog.confirm({
                message: '确认审核不通过？',
            }).then(() => {
                this.submitAPI(data, '审核不通过!', '/interfaceApi/basicplatform/simpleflow/processes');
            }).catch(() => {
                this.$toast('取消审核！');
            });
        },

        // 退回提交
        async returnSubmit() {
            const res = await this.phaseReturnStatusRequest(this.approvalData.business_instance_id, this.CurrentBusinessProcess.BusinessPhaseId);
            // 是退回提交，提交到数据返回的退回环节，不是退回提交，走提交方法
            if (res) {
                const data = {
                    BusinessInstanceId: this.approvalData.business_instance_id,
                    CurrentBusinessProcessId: this.CurrentBusinessProcess.CurrentBusinessProcessId,
                    TransferMode: 10,
                    NextPhsaeId: res.BusinessPhaseId,
                    NextApproverIds: res.ApproverId,
                    NextApproverNames: res.ApproverName,
                };
                let newText = '';
                if (res.ApproverName) {
                    newText = `提交到【${res.BusinessPhaseName}】环节的【${res.ApproverName}】进行办理？`;
                } else {
                    newText = `提交到【${res.BusinessPhaseName}】环节进行办理？`;
                }
                this.$dialog.confirm({
                    title: '确认提交',
                    message: newText,
                }).then(() => {
                    this.submitAPI(data, '提交成功!');
                }).catch(() => {
                    this.$toast('已取消操作!');
                });
            } else {
                this.submit();
            }
        },

        // 抄送
        async read() {
            if ((this.approvalData.business_instance_id || '') === '') {
                this.$toast('请先保存表单!');
                return;
            }
            this.$toast.loading({ overlay: true, duration: 0 });
            const res = await this.readRequest(this.approvalData.business_instance_id);
            if (res) {
                this.$toast.success('操作完成。');
                this.isReadOnly = true;
                if (this.isNews !== true) {
                    this.$router.isBack = 1;
                    this.$router.replace({
                        name: this.backPathName,
                        params: {
                            isRefresh: true,
                        },
                    });
                    this.$router.go(-1);
                }
            }
            this.$toast.clear();
        },

        // 流程提交请求
        async submitAPI(data, message, url) {
            this.$toast.loading({ overlay: true, duration: 0 });
            await this.submitAPIRequest(url, data);
            this.$toast.success(message);
            this.isReadOnly = true;
            if (this.isNews !== true) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: this.backPathName,
                    params: {
                        isRefresh: true,
                    },
                });
                this.$router.go(-1);
            }
            this.$toast.clear();
        },
        // 意见
        opinion() {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'approvalComments',
                params: {
                    approvalData: this.approvalData,
                    currentBusinessProcess: this.CurrentBusinessProcess,
                    businessInstanceInfo: this.BusinessInstanceInfo,
                    isReadOnly: this.isReadOnly,
                    isNews: this.isNews,
                    thisToken: this.newsToken,
                },
            });
        },
        // 拉取审批意见
        async getApprovalComments() {
            this.$toast.loading({ overlay: true, duration: 0 });
            let res = null;
            if (this.CurrentBusinessProcess?.ConfigPhaseId) {
                res = await this.getApprovalCommentsRequest();
            }
            // res == null, 没有意见表，不用验证意见是否已填
            if (!res) {
                this.isOpinion = true;
                this.isFillOpinion = false;
                this.isFillOpinion_return = false;
            }
            // else {
            //     this.isFillOpinion = true;
            //     this.isFillOpinion_return = true;
            // }
            if ((res?.opinion || '') !== '') {
                this.isOpinion = true;
            } else {
                this.isOpinion = false;
            }
            this.$toast.clear();
        },
        // 沟通
        async communicate() {
            if (this.contractNo === '') { return; }
            const res = await this.communicateRequest();
            if (!res.netease_group_id) {
                this.gitUserAccid(res);
            } else {
                const callMobileData = {
                    conversationId: res.netease_group_id,
                    name: res.group_name,
                    type: '1',
                };
                this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
            }
        },
        // 获取联系人云信id
        async gitUserAccid(data) {
            const res = await this.gitUserAccidRequest(data);
            if (res.length > 0) {
                const callMobileData = {
                    uids: res,
                    groupName: data.group_name,
                    type: '0',
                    contractId: this.contractNo,
                };
                this.$callMobile('JYTeamsNative', 'jyCreatedGroupWithContractInfo', callMobileData);
            }
            this.$toast.clear();
        },
        // 原生调js回传群组json
        callback_GetTeamsListInfo(chartGroupJson) {
            const groupData = JSON.parse(chartGroupJson).teams[0];
            if (groupData.teamid && groupData.teamid !== 'undefined') {
                const res = this.addContractNetease(groupData.teamid);
                if (res) {
                    this.groupChat(groupData);
                }
            }
        },

        // 点群组列表进入群组聊天
        groupChat(data) {
            const callMobileData = {
                conversationId: data.teamid,
                name: data.teamName,
                type: '1',
            };
            this.$callMobile('JYTeamsNative', 'GetConversationInfo', callMobileData);
        },

        // 工程地址打开地图
        configurationMethod(data) {
            if (data) {
                const parameter = data.match(/\(([^)]*)\)/)[1].split(',');
                const mapData = {
                    engineering_location: this.essentialInfoData[parameter[0]],
                    x_coordinate_point: this.essentialInfoData[parameter[1]],
                    y_coordinate_point: this.essentialInfoData[parameter[2]],
                };
                this.$router.isBack = 2;
                this.$router.push({
                    path: 'ProjectLocation',
                    query: {
                        data: mapData,
                        parentData: this.approvalData,
                        type: 'approvalProcess',
                    },
                });
            }
        },
        // 查看表单
        openForm(data) {
            this.$router.isBack = 2;
            if (data.AppFormUrl?.includes('appForm_')) {
                this.$router.push({
                    name: data.AppFormUrl,
                    params: {
                        listData: data,
                        formData: this.formData,
                    },
                });
            } else {
                this.$router.push({
                    name: 'formPreview',
                    params: {
                        formData: data,
                        approvalData: this.approvalData,
                        isNews: this.isNews,
                        thisToken: this.newsToken,
                    },
                });
            }
        },
        // 附件预览
        attachmentPreview(data) {
            if (data.FileType !== '1') {
                this.$router.isBack = 2;
                const fileFormat = data.FileName.substring(data.FileName.length - 4, data.FileName.length);
                if (
                    fileFormat.indexOf('jpg') > -1
                    || fileFormat.indexOf('png') > -1
                    || fileFormat.indexOf('gif') > -1
                    || fileFormat.indexOf('jpeg') > -1
                ) {
                    this.url = `${this.GLOBAL.FILE_BASE_URL}file-manage/${data.AFI_Code}/download`;
                    ImagePreview({
                        images: [this.url],
                        closeable: true,
                    });
                } else {
                    this.url = `${this.GLOBAL.FILE_BASE_URL}file-manage/preview/${data.AFI_Code}`;
                    this.$router.push({
                        name: 'attachmentPreview',
                        params: {
                            url: this.url,
                            isNews: this.isNews,
                        },
                    });
                }
            } else {
                this.thisFileID = data.FileID;
                this.attachmentData = this.allAttachmentData.filter(item => item.ParentID === data.FileID);
            }
        },

        // 附件返回上一级
        attachmentReturn() {
            const new_ParentID = this.allAttachmentData.filter(item => item.FileID === this.thisFileID)[0].ParentID;
            this.attachmentData = this.allAttachmentData.filter(item => item.ParentID === new_ParentID);
            this.thisFileID = this.attachmentData[0].ParentID;
        },

        // 单条提示已读
        async promptReadClick() {
            const res = await this.promptReadRequest(this.showUnreadData.RemindId);
            if (res) {
                this.showUnreadData.RecordStatus = 1;
                this.showTipsPopover = false;
            }
        },

        // 显示所有提示
        openAllTips() {
            this.showAllTips = true;
        },

        // 所有提示已读
        async allpromptReadClick() {
            const row = this.businessRemindList.filter(item => item.RecordStatus === 0);
            if (row.length > 0) {
                const res = await this.allPromptReadRequest(this.approvalData.business_instance_id);
                if (res) {
                    this.showAllTips = false;
                    this.businessRemindList.forEach(item => { item.RecordStatus = 1; });
                }
            } else {
                this.showAllTips = false;
            }
        },

        // 显示隐藏意见内容
        showOrHideOption(option) {
            if (option) {
                this.$set(option, 'showAll', !option.showAll);
            }
        },

        /**
         * 打开办理流程
         * 2022年6月10日14:43:14
         */
        async openHandlingProcess() {
            this.approvalPhaseData = await this.getApprovalPhaseData(this.approvalData.business_instance_id);
            this.showApprovalProcess = true;
        },

        // 多租户消息打开办理页面，取token
        getTenantToken(TenantId) {
            const qs = require('qs');
            let token = this.token = window.localStorage.getItem('token');
            token = token.split(' ')[1];
            return this.$axios.$post('/interfaceApi/login/switch_tenant', qs.stringify({
                token: token,
                tenantId: TenantId,
            }), {
                options: {
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                },
            });
        },

        // 获取基本信息字段数据请求
        getEssentialInfoFieldRequest() {
            const businessCode = this.approvalData.BusinessCode || this.BusinessInstanceInfo.BusinessCode;
            return this.$axios.$get(`/interfaceApi/basicplatform/mobile/get_fields/${businessCode}`, { token: this.newsToken });
        },

        // 获取基本信息数据请求
        getEssentialInfoDataRequest() {
            const businessCode = this.approvalData.BusinessCode || this.BusinessInstanceInfo.BusinessCode;
            const url = `/interfaceApi/basicplatform/mobile/get_form_data/${businessCode}/${this.approvalData.business_instance_id}`;
            return this.$axios.$get(url, { token: this.newsToken });
        },

        // 根据环节获取流程实例信息请求
        getProcessDataRequest() {
            const url = `${this.approvalData.business_instance_id}/${this.approvalData.BusinessProcessId}`;
            return this.$axios.$get(`/interfaceApi/basicplatform/simpleflow/processes/${url}`, { token: this.newsToken });
        },
        getProcessDataRequest_view(view = 'view') {
            return this.$axios.$get(`/interfaceApi/basicplatform/simpleflow/scene/${this.approvalData.business_instance_id}/${view}`, { token: this.newsToken });
        },

        // 流程提交请求
        submitAPIRequest(url, data) {
            return this.$axios.$post(url, data, { token: this.newsToken });
        },

        // 拉取审批意见请求
        getApprovalCommentsRequest() {
            const businessCode = this.approvalData.BusinessCode || this.BusinessInstanceInfo.BusinessCode;
            const url = `${businessCode}/${this.approvalData.business_instance_id}/${this.CurrentBusinessProcess.ConfigPhaseId}`;
            return this.$axios.$post(`/interfaceApi/basicplatform/mobile/get_opinion/${url}`, {}, { token: this.newsToken });
        },

        // 沟通请求
        communicateRequest() {
            return this.$axios.$get(`/interfaceApi/sale/contract_manager/get_contract_user_phone/${this.contractNo}`, { token: this.newsToken });
        },

        // 获取联系人云信id请求
        gitUserAccidRequest(data) {
            return this.$axios.$post('/interfaceApi/message/MessageNetease/get_accids', data.phones, { token: this.newsToken });
        },

        // 合同关联云信群组
        addContractNetease(teamid) {
            // eslint-disable-next-line max-len
            return this.$axios.put(`/interfaceApi/sale/contract_manager/add_contract_netease/${this.contractNo}/${teamid}`, {}, { token: this.newsToken });
        },

        // 环节退回状态请求
        phaseReturnStatusRequest(businessInstanceId, businessPhaseId) {
            const path = `/interfaceApi/basicplatform/simpleflow/processes/getlastreturnprocess/${businessInstanceId}/${businessPhaseId}`;
            return this.$axios.$get(path, { token: this.newsToken });
        },

        // 当前显示提示已读
        promptReadRequest(remindid) {
            const path = `/interfaceApi/basicplatform/simpleflow/businessinstance/click_businessremind/${remindid}`;
            return this.$axios.$put(path, {}, { token: this.newsToken });
        },

        // 全部提示已读请求
        allPromptReadRequest(businessInstanceId) {
            const path = `/interfaceApi/basicplatform/simpleflow/businessinstance/batch_click_businessremind/${businessInstanceId}`;
            return this.$axios.$put(path, {}, { token: this.newsToken });
        },

        // 按钮执行前拉取执行前条件
        getExecuteCondition(url) {
            return this.$axios.$get(url, { token: this.newsToken });
        },

        // 获取环节数据请求
        getLinkDataRequest(businessInstanceId, businessPhaseId) {
            const path = `/interfaceApi/basicplatform/simpleflow/processes/getcurrentbusinessprocess/${businessInstanceId}/${businessPhaseId}`;
            return this.$axios.$get(path, { token: this.newsToken, defEx: true });
        },

        // 拉取审批环节数据
        getApprovalPhaseData(businessInstanceId) {
            const url = `/interfaceApi/basicplatform/simpleflow/processes/getbusinessphaseflow/${businessInstanceId}`;
            return this.$axios.$get(url, { token: this.newsToken, defEx: true });
        },

        // 抄送请求
        readRequest(BusinessInstanceId) {
            return this.$axios.$get(`/interfaceApi/basicplatform/simpleflow/cc/read?businessInstanceId=${BusinessInstanceId}`, { token: this.newsToken });
        },
    },
};
</script>
<style lang="stylus">
.approvalProcess
    height 100%
    display flex
    flex-direction column
    &.isNews
        .van-nav-bar
            display none !important
        section
            height calc(100% - 40rpx)
    section
        flex 1
        height 0
        overflow hidden
        position relative
        &.readOnly
            height calc(100% - 45rpx)
        .van-tabs
            height 100%
            .van-tabs__wrap
                border-bottom 1px solid #E5E9F2
            .van-tab
                .van-tab__text
                    font-size 14rpx
                &.van-tab--active
                    .van-tab__text
                        color #ee0a24
            .van-tabs__content
                height calc(100% - 40rpx)
                .van-tab__pane-wrapper
                    height 100%
                    overflow-x hidden
                    overflow-y scroll
                    -webkit-overflow-scrolling touch
                .noData
                    font-size 40rpx
                    line-height 200rpx
                    font-weight 600
                    color #ccc
                    text-align center
                .van-cell, .van-cell__left-icon
                    font-size 16rpx
                .van-cell
                    padding 16rpx
                .essentialInfo
                    // padding 10rpx
                    background #F0F0F0
                    .van-collapse
                        padding-bottom 70rpx
                    .van-cell
                        min-height 42rpx
                        padding 0 14rpx
                        align-items center
                        &:after
                            left 0
                            width 100%
                            border-color #F0F0F0
                        .van-cell__title
                            font-size 14rpx
                            color #061F3E
                        .van-cell__value
                            font-size 14rpx
                            color #626262
                .formList
                    &:before
                        color #5588F1
                        font-size 20rpx
                        margin-right 15rpx

                .appendix_list
                    .attachmentReturnBtn
                        width 100%
                        height: 30rpx
                        border 1px solid #91D5FF
                        background: #E6F7FF
                        font-size 12rpx
                        color #1890FF
                    ul
                        li
                            display flex
                            align-items center
                            width 100%
                            padding 12rpx
                            border-bottom 1px solid #ebedf0
                            >i
                                line-height: 50rpx
                                width 30rpx
                                text-align: right
                                display: none
                            &.folder
                                i
                                    display: block
                            &.file
                                .fileInfo
                                    width calc(100% - 50rpx)
                    .fileName
                        width 100%
                        white-space nowrap
                        text-overflow ellipsis
                        overflow hidden
                    .fileIcon
                        font-size 16rpx
                        width 50rpx
                        text-align center
                        height 50rpx
                        line-height 50rpx
                        &:first-child
                            font-size 26rpx
                        &:last-child
                            font-size 14rpx
                            color #979EA7
                        &.sm-tupian::before
                            color rgba(133, 115, 226, 1)
                        &.sm-pdf1::before
                            color rgba(255, 85, 98, 1)
                        &.sm-bg-word::before
                            color rgba(84, 141, 254, 1)
                        &.sm-xls::before
                            color rgba(72, 203, 129, 1)
                        &.sm-ppt::before
                            color rgba(255, 147, 51, 1)
                        &.sm-txt::before
                            color #f60
                    .fileInfo
                        width calc(100% - 50rpx)
                        p
                            font-size 16rpx
                            color #000
                            line-height 24rpx
                            &:last-child
                                display flex
                                justify-content space-between
                                em
                                    font-size 14rpx
                                    color #979EA7
                .flowChartList
                    width 100%
                    height 100%
                    overflow hidden
                    overflow-y auto
                    padding 14rpx
                    .procedureList
                        position relative
                        padding-bottom 24rpx
                        &:last-child
                            &:before
                                display: none
                        &:before
                            content ''
                            width 1px
                            height 100%
                            background #D7D7D7
                            position absolute
                            top 8rpx
                            left 20rpx
                        &.countersignatureNode
                            &:after
                                content ''
                                width 1px
                                height calc(100% - 125rpx)
                                background: url(./images/up.png) repeat-y
                                position absolute
                                top 11rpx
                                left 50rpx
                            .countersignatureTitle
                                display: flex
                                position: relative
                                z-index 9
                                color #FA6400
                                font-size: 16rpx
                                line-height: 24rpx
                                padding-left: 15rpx
                                margin-bottom: 20rpx
                                &:before
                                    content ''
                                    width 10rpx
                                    height 1px
                                    background: url(./images/across.png) repeat-x
                                    position absolute
                                    top 10rpx
                                    left 41rpx
                                i
                                    width 24rpx
                                    height 24rpx
                                    background: #FA6400
                                    color #fff
                                    text-align: center
                                    line-height: 24rpx
                                    font-size: 16rpx
                                    border-radius: 50%
                                    margin-right: 20rpx
                            .listBox
                                padding-left: 70rpx
                                position: relative
                                h4
                                    color #FA6400
                                    position: relative
                                    &:before
                                        content ''
                                        width 35rpx
                                        height 1px
                                        background: url(./images/across.png) repeat-x
                                        position absolute
                                        top 10rpx
                                        left -39rpx
                        .listBox
                            h4
                                font-size 16rpx
                                line-height 16rpx
                                color #EB0002
                                padding-left 35rpx
                                margin-bottom: 8rpx
                                margin-left: 16rpx
                                display: flex
                                position: relative
                                z-index 9
                                &:after
                                    content ''
                                    width 8rpx
                                    height 8rpx
                                    border-radius 50%
                                    background #EB0002
                                    position absolute
                                    top 0
                                    left 0
                            .userInfo
                                overflow hidden
                                display flex
                                span
                                    display: inline-block
                                    font-size 14rpx
                                    line-height 20rpx
                                    &.headPortrait
                                        position relative
                                        p
                                            width 40rpx
                                            height 40rpx
                                            font-size 14rpx
                                            line-height 40rpx
                                            text-align center
                                            color #FFFFFF
                                            background linear-gradient( 199deg, #F57D51 0%, #F94E4D 100%)
                                            border-radius 8rpx
                                        .icon
                                            position absolute
                                            bottom 0
                                            right 0
                                            width 15rpx
                                            height 15rpx
                                            background url('./images/dsp.png') no-repeat
                                            background-size 15rpx 15rpx
                                            &.icon_pass
                                                background url('./images/pass.png') no-repeat
                                                background-size 15rpx 15rpx
                                    &.name
                                        color #001A2C
                                        margin-left 15rpx
                                    &.state
                                        color #00AC86
                                    &.time
                                        margin-left 10rpx
                                        color #868FA3
                                        font-size: 12rpx
                                        margin-right auto
                                div
                                    width 100%
                                .stateBox
                                    display flex
                                    justify-content space-between
                                    align-items center
                            .opinions
                                margin-top 6rpx
                                margin-left: 50rpx
                                background: #F0F7FF
                                padding 6rpx 15rpx
                                position relative
                                overflow hidden
                                .opinion-text
                                    display -webkit-box
                                    font-size 14rpx
                                    line-height 20rpx
                                    color #3183FF
                                    -webkit-box-orient vertical
                                    -webkit-line-clamp 2
                                    overflow hidden
                                &.show-all
                                    .opinion-text
                                        display flex
                                    .sm-shuangjiantouxia
                                        transform rotate(180deg)
                                .sm-shuangjiantouxia
                                    position absolute
                                    right 2rpx
                                    top 28rpx
                                    font-size 16rpx
                                    color #0185FE
                            .commentList
                                margin-left: 40rpx
                                margin-top 10rpx
                                background #eef7ff
                                li
                                    border-bottom: 1px solid #E5E9F2
                                    font-size: 12rpx
                                    line-height: 18rpx
                                    color #4A4A4A
                                    padding 8rpx 12rpx
                                    &:last-child
                                        border-bottom none
                                    .comment
                                        font-size 13rpx
                                        color #155a9a
        .sm-fujian
            color #3495FB
        .communicate, .opinion, .tipsBtn
            position absolute
            width 45rpx
            height 45rpx
            border none
            background #e40002
            right 15rpx
            bottom 15rpx
            font-size 12rpx
            color #fff
            border-radius 50%
            p
                font-size 16rpx
        .tips
            position absolute
            right 15rpx
            bottom 15rpx
            width 45rpx
            height 45rpx
            .tipsBtn
                position initial
                background #F48400
                p
                    font-size 20rpx
            .van-badge
                top 3rpx
                right 3rpx
            .tipsPopover
                color #F48400
                display flex
                position absolute
                right 55rpx
                bottom 0
                width 280rpx
                padding 10rpx 30rpx 10rpx 10rpx
                border-radius 4rpx
                background #FFF5D1
                border 1px solid #FFDFAD
                box-shadow -4px 4px 8px rgba(0, 0, 0, 0.3)
                i
                    font-size 20rpx
                    color #F48400
                    margin-right 5rpx
                span
                    border-color: transparent transparent transparent #FFDFAD;
                    border-style: solid;
                    border-width: 8px 0px 8px 8px;
                    width: 0;
                    height: 0;
                    position absolute
                    left 100%
                    bottom 12rpx
                button
                    width 30rpx
                    height 30rpx
                    border none
                    background none
                    position absolute
                    right 1px
                    top 1px
                p
                    font-size 14rpx
        .flowPathTips
            width 80%
            padding: 14rpx 0
            text-align: center
            border-radius 4rpx
            ul
                li
                    border-bottom 1px solid #F0F0F0
                    padding-bottom: 14rpx
                    padding-top 14rpx
                    &:first-child
                        padding-top 0
                    >div
                        display flex
                        justify-content space-between
                        .state
                            white-space nowrap
                            height: 20rpx
                            font-size 12rpx
                            line-height: 20rpx
                            position relative
                            background: linear-gradient(90deg, #55A7FE 0%, #3E79C5 100%);
                            color #fff
                            padding: 0 3px
                            &:before
                                content ''
                                width 0
                                height 0
                                border-top 10rpx solid transparent
                                border-left 10rpx solid #3E79C5
                                border-bottom 10rpx solid transparent
                                position absolute
                                left 100%
                            &.read
                                background: linear-gradient(90deg, #CBCCCD 0%, #B6B7B8 100%);
                                &:before
                                    border-left-color #B6B7B8
                        p
                            font-size: 14rpx
                            line-height: 20rpx
                            width: calc(100% - 50rpx)
                            padding-right: 14rpx
                            text-align: left
                    >p
                        font-size: 12rpx
                        color #979EA7
                        text-align: right
                        padding-right: 14rpx
                        margin-top: 14rpx
            .van-button
                width 120rpx
                height 32rpx
                margin-top: 14rpx
    footer
        padding 0 15rpx
        display flex
        align-items center
        justify-content space-around
        height 70px
        background #FFFFFF
        box-shadow 0px 0px 6rpx 0px rgba(0, 0, 0, 0.2)
        button
            flex 1
            height 38rpx
            margin 0 5rpx
            border 1px solid #E40002
            font-size 14rpx
            position relative
            background #fff
            color #E40002
            border-radius 4px
            &:last-child
                background #E40002
                color #fff
            &.moreBtn
                border 1px solid #E40002
                color #E40002
                background #fff
    .van-popover__content
        background: #FFFFFF;
        border-radius 3rpx
        .moreBtn-item
            width 95rpx
            height 40rpx
            display flex
            justify-content center
            align-items center
            font-size 16rpx
            font-weight: 500;
            color #E40002
            border-bottom 1px solid #E40002
            &:last-child
                border 0
    .submitPopUp
        .van-dialog__header
            padding-top 0
            line-height 50rpx
        .van-dialog__content
            padding 15rpx
            border-top 2px solid #F0F0F0
            text-align center
            .icon, .info
                display inline-block
                vertical-align top
            .icon
                width 94rpx
                height 84rpx
                img
                    height 100%
            .info
                text-align left
                margin-top 15rpx
                h4
                    line-height 20rpx
                    font-size 14rpx
                    color #666666
                    margin-bottom 20rpx
                    span
                        font-size 16rpx
                        color #eb0002
                p
                    font-size 14rpx
                    color #979EA7
                &.linkInfo
                    width 100%
                    h4
                        margin-bottom 10rpx
    .approvalProcessPopUp
        width 90%
        height 90%
        border-radius 4rpx
        .van-popup__close-icon
            top 10rpx
            right 10rpx
        header
            color #fff
            height 40rpx
            font-size 16rpx
            line-height 40rpx
            text-align center
            background url('../../assets/images/common/title.png') top center no-repeat
            background-size: 100%
        ul
            height calc(100% - 40rpx)
            padding 15rpx 15rpx 15rpx 0
            overflow-x hidden
            overflow-y scroll
            -webkit-overflow-scrolling touch
            .processNode
                display flex
                padding-bottom 20rpx
                &:first-child
                    .nodeList
                        .childNode
                            div
                                background #E2FCDC
                                i
                                    background #44D76E
                &:last-child
                    .nodeIcon
                        &:before
                            display none
                    .nodeList
                        .childNode
                            div
                                background #FFF1F0
                                i
                                    background #FF595B
            .nodeIcon
                width 50rpx
                text-align center
                position: relative
                &:before
                    content ''
                    width 2px
                    height calc(100% + 14rpx)
                    background: url(./images/up.png) repeat-y
                    position: absolute
                    top 6rpx
                    left 50%
                    margin-left -1px
                span
                    display inline-block
                    position: relative
                    z-index 2
                .startNodeIcon,.endNodeIcon
                    width 20rpx
                    height 20rpx
                    line-height 20rpx
                    text-align center
                    font-size 12rpx
                    color #fff
                    border-radius 50%
                .startNodeIcon
                    background #44D76E
                .endNodeIcon
                    background #FF595B
                .intermediateNodeIcon
                    width 12rpx
                    height 12rpx
                    background: url(./images/decorate.png) no-repeat
                    background-size 100%
                .countersignatureIcon
                    width 24rpx
                    height 24rpx
                    line-height 24rpx
                    text-align center
                    font-size 12rpx
                    color #fff
                    border-radius 50%
                    background #0185FE
            .nodeList
                position: relative
                &.countersignatureNode
                    padding 20rpx
                    border 1px solid #C4E3FF
                    background #F9FCFE
                .angleSign
                    width 40rpx
                    height 40rpx
                    position: absolute
                    top 0
                    left 0
                    color #1890FF
                    font-size 40rpx
                    line-height: 40rpx
                    i
                        font-size 12rpx
                        color #fff
                        position: absolute
                        top -8px
                        left 0
                        transform: rotate(-45deg)
                        transform-origin center
                .childNode
                    margin-bottom 10rpx
                    &:last-child
                        margin-bottom: 0
                    div
                        width 200rpx
                        height 40rpx
                        background #DCF5FC
                        border-radius 4rpx
                        display flex
                        i
                            width 24rpx
                            height 24rpx
                            border-radius 50%
                            text-align center
                            line-height 24rpx
                            color #fff
                            background #17A8FD
                            margin: 8rpx
                        span
                            font-size 14rpx
                            color #2F2E2E
                            line-height 40rpx
                            max-width: calc(100% - 50rpx)
                            overflow hidden
                            text-overflow: ellipsis
                            white-space: nowrap
                    p
                        font-size 14rpx
                        line-height 26rpx
                        color #DC8D1D
</style>
